import { itemHasContent } from '../../utils/helpers';

const CHANNEL_FIELDS = ['name', 'description'];

export default function calculateChannelProgress(rootState, minRequired = 1) {
  let filledCount = 0;
  let totalCollectionItems = 0;

  if (rootState.channel.collection.length) {
    rootState.channel.collection.forEach((item) => {
      let foundUnfilledField = false;
      CHANNEL_FIELDS.forEach((field) => {
        if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });
      if (!foundUnfilledField) filledCount += 1;
    });
  }
  totalCollectionItems += rootState.channel.collection.length;

  if (filledCount === 0) return 0;
  const denominator = Math.max(minRequired, totalCollectionItems);
  const sectionProgress = Math.round((filledCount / denominator) * 100);
  return sectionProgress;
}
